import { combineReducers } from 'redux';
import context from './ducks/context';
import feeds from './ducks/feeds';
import lists from './ducks/lists';
import modals from './ducks/modals';
import browserWindow from './ducks/browserWindow';
import suggestedUserConnections from './ducks/suggestedUserConnections';
import inviteUserConnections from './ducks/inviteUserConnections';
import findFriends from './ducks/findFriends';
import connectFlow from './ducks/connectFlow';
import followerRequests from './ducks/followerRequests';
import belay from './ducks/belay';
import userOverrides from './ducks/userOverrides';

export default combineReducers({
  browserWindow,
  context,
  feeds,
  lists,
  modals,
  suggestedUserConnections,
  inviteUserConnections,
  findFriends,
  connectFlow,
  followerRequests,
  belay,
  userOverrides
});
